import { render, staticRenderFns } from "./Affix.vue?vue&type=template&id=5d4e6f2c"
import script from "./Affix.vue?vue&type=script&lang=js"
export * from "./Affix.vue?vue&type=script&lang=js"
import style0 from "./Affix.vue?vue&type=style&index=0&id=5d4e6f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports